import { NgModule } from '@angular/core';
import { AuthGuardService } from './services/auth-guard.service';
import { LoggedInAuthGuardService } from './services/logged-in-auth-guard.service';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('./auth/login/login.module').then( m => m.LoginPageModule),
    canActivate: [ LoggedInAuthGuardService ]
  },
  {
    path: 'main',
    loadChildren: () => import('./main/main.module').then( m => m.MainPageModule),
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'vin',
    loadChildren: () => import('./vehicle/vin/vin.module').then( m => m.VinPageModule)
  },
  {
    path: 'operativa',
    loadChildren: () => import('./operativa/operativa.module').then( m => m.OperativaPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
